import { api, API } from "./api";
import { getUserId, setUserId, resetAnon } from "./user";

// The backend owns the OAuth handshake: it builds Google's consent URL with a
// single-use state, then redirects back to the app with the session cookie set.
// The anonymous id rides along so any sessions created before sign-in get
// merged into the account.
export function googleLogin() {
  const anon = getUserId();
  window.location.href = `${API}/auth/google/login?anonUserId=${encodeURIComponent(anon)}`;
}

// After the redirect the cookie is already set — we only need the account id so
// future anonymous-keyed calls point at the right user.
export async function completeAuth() {
  const user = await api.authMe();
  setUserId(user.id);
  return user;
}

export async function logout() {
  try {
    await api.authLogout();
  } catch (e) {
    // ignore
  }
  resetAnon();
  window.location.href = "/";
}
